import gql from "graphql-tag";

export const AdressFragment = gql`
  fragment AdressFragment on Address {
    country
    city
    region
    address
    additional_address
    location {
      latitude
      longitude
    }
    place_id
  }
`;

export const RequestItemsFragment = gql`
  fragment RequestItemsFragment on Items {
    product {
      _id
      name
      description
      reference
      weight
      volume
      value
      pickup
    }
    counter
  }
`;
export const ActivityFragment = gql`
  fragment ActivityFragment on Activity {
    _id
    activity_date
    activity_trigger_action
    activity_trigger_action_data
    activity_trigger_action_data_reason
    activity_trigger_by_user_id
    activity_updated_by {
      _id
      first_name
      last_name
      email
      phone_number
    }
    activity_trigger_source
    activity_source_UID
    activity_source_context
  }
`;

export const TemplateStopsFragment = gql`
  fragment TemplateStopsFragment on TemplateStop {
    libelle
    request
    action
    address {
      ...AdressFragment
    }
    itemsToPick {
      ...RequestItemsFragment
    }
    itemsToDelivered {
      ...RequestItemsFragment
    }
    position
  }
  ${AdressFragment}
  ${RequestItemsFragment}
`;

export const RequestCreationResponseFragment = gql`
  fragment RequestCreationResponseFragment on Request {
    _id
    price
    documents {
      link
    }
  }
`;

export const RequestListFragment = gql`
  fragment RequestListFragment on Request {
    _id
    uid
    clientId
    client {
      client_company_name
    }
    type
    status
    vehicles {
      vehicleType
      numberOfVehicule
    }
    startDate
    endDate
    slotStart
    slotEnd
    address {
      ...AdressFragment
    }
    documents {
      _id
      libelle
      link
      request {
        _id
      }
    }
    productType
    additionnalInfos
    reccurenceType
    reccurenceOptions {
      each
      days
      value
    }
    price
    documents {
      libelle
      link
      isDeleted
    }
    templateAxes {
      name
      type
      templateStops {
        ...TemplateStopsFragment
      }
      vehicles {
        vehicleType
        numberOfVehicule
        price
        discount
      }
      slotStart
      slotEnd
      reccurenceType
      reccurenceOptions {
        each
        days
        value
      }
      price
      discount
    }
    createdAt
    editedAt
    isDeleted
    templateStops {
      ...TemplateStopsFragment
    }
    request_activities {
      ...ActivityFragment
    }
    view {
      byClient
    }
    dispatcher {
      numberOfDispatcher
      price
    }
    handler {
      numberOfHandler
      price
    }
  }
  ${ActivityFragment}
  ${AdressFragment}
  ${TemplateStopsFragment}
`;
